<template>
    <Transition name="modal">
        <slot></slot>
    </Transition>
</template>

<style lang="scss" scoped>
.modal-enter-active {
    transition: opacity 0.15s var(--timing-function-easing-emphasized);
}

.modal-leave-active {
    transition: opacity 0.09s var(--timing-function-easing-emphasized-reverse);
}

.modal-enter-from,
.modal-leave-to {
    opacity: 0;
}
</style>
